import React from "react";
import { Close } from "../../assets/svg";

const SuccessReset = ({ onClose, showSuccessType }) => {
  return (
    <div className="model" onClick={onClose}>
      <div
        className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-[391px] h-[186px] py-8 px-6 mx-auto relative"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <button
          type="button"
          onClick={onClose}
          className="flex justify-end w-full"
        >
          <Close />
        </button>
        <h2 className="text-[34px] font-Montserrat mb-3 text-center text-primaryBlack">
          Successfully Reset
        </h2>
        <h2 className="text-sm text-primaryBlack font-normal font-Proxima	 w-[240px]  mb-3 text-center">
          Successfully Reset{" "}
          {showSuccessType === "password"
            ? "Your Password"
            : "the 4-digit pin. Email are sent out"}
          .
        </h2>
      </div>
    </div>
  );
};

export default SuccessReset;
